import React, { useEffect } from "react";
// import Header from './../components/Header';
import xls from "xlsx";
import { useState, useRef } from "react";
import { useHistory, Link } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import { Container, Row, Col } from "reactstrap";
import Dropdown from "react-bootstrap/Dropdown";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import { uploadTransaction } from "./../stores/services/beta-transaction.service";
import { JsonToTable } from "react-json-to-table";

// import { getFundByAmc } from "./../stores/services/funds.service";
// import { getAccountByFund } from "./../stores/services/account.service";
import { Modal } from "react-bootstrap";
import moment from "moment";
import * as fs from "fs";
import { uploadTransaction } from "../../stores/services/beta-transaction.service";
import { getFundByAmc } from "../../stores/services/funds.service";
import { getAccountByFund } from "../../stores/services/account.service";
import { env } from "../../env";
import { useSelector } from "react-redux";
import {
  getAllSecurityTypesArr,
  numberWithCommas,
  shouldHighlight,
} from "../../utils/customFunction";
import { getAllUnitHoldersByAmc } from "../../stores/services/unit-holder.service";
import { legacyUploaderTXN } from "../../stores/services/legacyUploader";
import { getSecurities } from "../../stores/services/security.service";

let csvToJson = require("convert-csv-to-json");
const csv = require("csvtojson/v2");

let xlsxToJson = require("convert-excel-to-json");
// const xlsx = require('xlsx-to-json');

const LegacyPastTransactionUploader = () => {
  const theme = useSelector((state: any) => state.ThemeModeReducer.Theme);

  const arrAllHeadings = [
    "FundCode",
    "AccountTitle",
    "TransactionType",
    "TotalHolding",
    "txnid",
    "InstructionDate",
    "SettlementDate",
    "ModeofPayment",
    "InstrumentType",
    "InstrumentNo./ReferenceNo",
    "InstrumentDate/DepositDate",
    "FolioNumber",
    "UnitHolderName",
    "SaleDate",
    "NAVPrice",
    "SalePrice",
    "RedemptionPrice",
    "RedemptionDate",
    "DiscountonLoad",
    "ApplicableUnitLoad",
    "ApplicablePrice",
    "Unitssold",
    "UnitsRedeemed",
    "CurrentHolding",
    "RemainingHolding",
    "Detail",
    "GrossAmount",
    "SaleLoad",
    "RedemptionLoad",
    "CGT",
    "Zakat",
    "NetAmount",
    "PaymentType",
    "FundAccount",
    "AccountNumber",
    "Bank",
    "Branch",
    "FolioNo",
    "Name",
    "TransferUnits",
    "CounterAccount",
    "CounterAccountTitle",
    "CounterAccountNumber",
    "CounterBank",
    "CounterBranch",
    "Advisor",
    "SalesTaxCollector",
    "SST/PST%",
    "SST/PSTAmount",
    "TotalAmount",
    "WHIT%",
    "WHIncomeTaxAmount",
    "WHST%",
    "WHSaleTaxAmount",
    "Auditor",
    "Custody",
    "ShariahAdvisory",
    "CDC",
    "PSX",
    "Printing",
    "Legal/Professional",
    "PACRA,VISCreditRating",
    "FBR,SRB,PST",
    "LedgerTypeGrossAmount",
    "LedgerTypeSST/PST",
    "TaxType",
    "EquityBroker,MoneyMarketBroker",
    "NCCPLMargin",
    "Symbol",
    "Volume",
    "ParValue",
    "AnnouncementDate",
    "DividendPercentage",
    "DividendCreditDate",
    "DividendAmount",
    "BonusPercentage",
    "BonusShare",
    "BonusCreditDate",
    "RightSharePercentage",
    "RightShare",
    "RightShareCreditDate",
    "RightShareSymbol",
    "TotalMarketValue",
    "AverageCostBeforeRight",
    "Premium",
    "CostAfterRight",
    "DifferenceBetweenRightPrice",
    "CostofRightEntitled",
    "NCCPLMargin,NCCPLIDS,EquityBroker",
    "SettlementBy",
    "AverageCostAmount",
    "GainLossAmount",
    "BrokerageCommission",
    "SSTonCommission",
    "MoneyMarketBroker",
    "TotalFaceValue",
    "AccruedAmount",
    "PremiumDiscount",
    "Brokerage",
    "PrincipalAmount",
    "Difference",
    "DebitLedger",
    "DebitAmount",
    "DebitDescription",
    "DebitInvoiceNumber",
    "CreditLedger",
    "CreditAmount",
    "CreditDescription",
    "CreditInvoiceNumber",
    "FundName",
    "FromDate",
    "ToDate",
    "Code",
    "AccruedExpense",
    "ActualExpense",
    "Balance",
    "QuarterlyFee",
    "DailyExpense(Quarterly)",
    "HalfYearlyFee",
    "DailyExpense(HalfYearly)",
    "AnnualFee",
    "DailyExpense(Annual)",
    "TotalExpense",
    "Account",
    "Profit%",
    "BankCode",
    "DailyProfit",
    "ActualProfit",
    "AccruedProfit",
    "CurrentNetAssets",
    "SlabFrom",
    "SlabTo",
    "ApplicableRate",
    "FixedAmount",
    "TrusteeFee",
    "TrusteeFeeTaxRate",
    "TrusteeFeeTax",
    "ManagementFee",
    "ManagementFeeTaxRate",
    "ManagementFeeTax",
    "SECPFee",
    "Accounting&OperationalFeeDetails",
    "PayableAmount",
    "ActualPayment",
    "Add Security Popup",
    // "SecurityType",
    "Securities/Placement",
    "Type",
    "Market",
    "Broker",
    "InvestmentType",
    "Quantity",
    "CommissionCharges",
    "CommissionRate",
    "SecuritySSTOnCommission",
    "Gain/LossPerUnit",
    "SecuritySalePrice",
    "NetRate",
    "Security",
    "IssueDate",
    "MaturityDate",
    "MoneyMarketFaceValue/Unit",
    "LastCouponDate",
    "NextCouponDate",
    "CouponRate",
    "CouponPayment/Year",
    "CouponDays",
    "AccruedDays",
    "SecurityDetail",
    "PurchasePrice",
    "Units",
    "Yield/InterestRate",
    "SecurityTotalFaceValue",
    "SecurityPrincipalAmount",
    "SecurityAccruedAmount",
    "UnRedeemValue",
    "SecurityBrokerage",
    "SettlementAmount",
    "MaturityAmount",
    "CouponMaturityAmount",
    "Premium/Discount",
    "FundIPSAccount",
    "CounterPartyIPSAccount",
    "BrokerName",
    "CounterPartyName",
    "AverageCost/Unit",
    "SecurityAverageCostAmount",
    "Gain/LossAmount",
    "DaysOfMaturity",
    "PrimaryDealer",
  ];

  const history = useHistory();
  const amcCode = sessionStorage.getItem("amc_code") || "";
  const fund_code = JSON.parse(sessionStorage.getItem("fund_code") || "[]");

  const [allAvailableFunds, setAllAvailableFunds] = useState<any>([]);
  const [allSecurities, setAllSecurities] = useState<any>([]);

  const [loading, setLoading] = useState(false);
  const [apiLoading, setApiLoading] = useState(false);
  const [fileData, setfileData] = useState<any>([]);
  const [fileDataCount, setFileDataCount] = useState(0);
  const myRef1 = useRef<HTMLInputElement>(null);
  const [fileName, setFileName] = useState("");
  const [fileError, setFileError] = useState("");
  const [activeUnitHolders, setActiveUnitHolders] = useState<any>([]);
  const [file, setFile] = useState("");
  const [fileUploadingFlag, setFileUploadingFlag] = useState<boolean>(false);
  const email = sessionStorage.getItem("email") || "";

  const getUnitHolders = async () => {
    try {
      setApiLoading(true);
      let res = await getAllUnitHoldersByAmc(email, amcCode, "");
      if (res?.status === 200 && res?.data?.status === 200) {
        const temp = res?.data?.data?.map(
          (item) => `${item.folio_no.replace("UNITHOLDER_", "")}`,
        );
        setActiveUnitHolders(temp);
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setApiLoading(false);
    }
  };

  const allFunds = async () => {
    try {
      let res = await getFundByAmc(email, amcCode);
      if (res?.status === 200 && res?.data?.status === 200) {
        const temp = res?.data?.data?.map((item) => `${item?.symbol_code}`);
        setAllAvailableFunds(temp);
      }
    } catch (error) {
      console.log("error fetching funds", error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setApiLoading(true);
      try {
        await Promise.all([allFunds(), getUnitHolders()]);
      } catch (error) {
        console.log("Error during initial data fetch", error);
      } finally {
        setApiLoading(false);
      }
    };

    fetchData();
  }, [email, amcCode]);

  useEffect(() => {
    const AllSecurities = async () => {
      try {
        let res = await getSecurities(email, amcCode);
        if (res?.status === 200 && res?.data?.status === 200) {
          const temp = res?.data?.data;
          setAllSecurities(temp);
        }
      } catch (error) {
        console.log("error fetching funds", error);
      }
    };
    AllSecurities();
  }, []);

  const investmentTXN = [
    "conversionout",
    "conversionin",
    "saleofunit",
    "redemptionofunits",
    "transferout",
    "transferin",
    "transferlienin",
    "transferlienout",
    "bonus",
    "bonusencashment",
    "taxonbonusencashment",
    "dividend",
    "taxondividend",
    "dividendpaid",
    "dividendreinvestment",
    "taxabledividend",
    "refundofcapital",
    "cgtonconversion",
    "cgtonconversionout",
    "cgtontransfer",
    "cgtonredemption",
    "cgtrefund",
    "zakatonbonusencashment",
    "zakatondividend",
  ];

  const validTXNType = [
    "conversionout",
    "conversionin",
    "saleofunit",
    "redemptionofunits",
    "transferout",
    "transferin",
    "transferlienin",
    "transferlienout",
    "bonus",
    "bonusencashment",
    "taxonbonusencashment",
    "dividend",
    "taxondividend",
    "dividendpaid",
    "dividendreinvestment",
    "taxabledividend",
    "refundofcapital",
    "cgtonconversion",
    "cgtonconversionout",
    "cgtontransfer",
    "cgtonredemption",
    "cgtrefund",
    "zakatonbonusencashment",
    "zakatondividend",
    "debtmarketinvestment",
  ];

  const requiredSaleOfUnit = [
    "FundCode",
    "AccountNumber",
    "AccountTitle",
    "txnid",
    "SettlementDate",
    "ModeofPayment",
    "FolioNumber",
    "UnitHolderName",
    "SalePrice",
    "SaleDate",
    "ApplicableUnitLoad",
    "Unitssold",
    "ApplicablePrice",
    "TotalHolding",
    "PaymentType",
    // "Detail",
    "FundAccount",
    "GrossAmount",
    "SaleLoad",
    "NetAmount",
    "CurrentHolding",
    "NAVPrice",
    "InstructionDate",
  ];

  const requiredRedemptionOfUnit = [
    "FundCode",
    "txnid",
    "AccountNumber",
    "AccountTitle",
    "SettlementDate",
    "ModeofPayment",
    "FolioNumber",
    "UnitHolderName",
    "RedemptionPrice",
    "RedemptionDate",
    "ApplicableUnitLoad",
    "UnitsRedeemed",
    "ApplicablePrice",
    "PaymentType",
    "RemainingHolding",
    // "Detail",
    "FundAccount",
    "GrossAmount",
    "NetAmount",
    "CurrentHolding",
    "NAVPrice",
    "CounterAccountTitle",
  ];

  // step 1
  const requiredConversionOutUnit = [
    "FundCode",
    "txnid",
    "AccountNumber",
    "AccountTitle",
    "SettlementDate",
    "ModeofPayment",
    "CounterAccount",
    "CounterAccountTitle",
    "FolioNumber",
    "UnitHolderName",
    "RedemptionPrice",
    "RedemptionDate",
    "RemainingHolding",
    "ApplicableUnitLoad",
    "ApplicablePrice",
    "PaymentType",
    "UnitsRedeemed",
    "CurrentHolding",
    // "Detail",
    "NAVPrice",
    "FundAccount",
    "GrossAmount",
    "NetAmount",
  ];

  // step 2
  const requiredConversionInUnit = [
    "FundCode",
    "txnid",
    "AccountNumber",
    "AccountTitle",
    "SettlementDate",
    "ModeofPayment",
    "FolioNumber",
    "UnitHolderName",
    "SalePrice",
    "SaleDate",
    "PaymentType",
    "ApplicableUnitLoad",
    "ApplicablePrice",
    "TotalHolding",
    "Unitssold",
    "CurrentHolding",
    // "Detail",
    "NAVPrice",
    "FundAccount",
    "GrossAmount",
    "NetAmount",
  ];

  // step 2
  const requiredMM = [
    "FundCode",
    "Units",
    "txnid",
    "AccountNumber",
    "AccountTitle",
    "SettlementDate",
    "ModeofPayment",
    // "Detail",
    "FundAccount",
    "GrossAmount",
    "NetAmount",
    "CounterAccountTitle",
    "Securities/Placement",
    "Type",
    "IssueDate",
    "MaturityDate",
  ];

  let date = new Date();
  const [megatxnObj, setMegatxnObj] = useState<any>([]);
  const [errorInFile, setErrorInFile] = useState(false);
  const [loadingFileUpload, setLoadingFileUpload] = useState(false);

  const upload = async (e: any) => {
    if (e?.target.files[0] && e.target.value) {
      setFileError("");
      setfileData(null);
      let file = e?.target.files[0];

      let type = file?.name?.substring(file?.name?.lastIndexOf(".") + 1);
      if (type === "xlsx" || type === "csv") {
        setFile(file);
        setFileName(file?.name);
        //start

        const reader = new FileReader();
        const rABS = !!reader.readAsBinaryString;
        reader.onload = (e) => {
          const bstr = e.target?.result;
          const wb = xls.read(bstr, { type: rABS ? "binary" : "array" });

          const sheetNames = wb.SheetNames;
          const allSheetsData = {};
          let ledgerData: any;
          let data: any;

          sheetNames?.forEach((sheetName) => {
            const ws = wb.Sheets[sheetName];
            const data1 = xls.utils.sheet_to_json(ws, {
              header: 2,
              raw: false,
              defval: "",
              dateNF: "YYYY-MM-DD",
            });

            allSheetsData[sheetName] = data1;

            if (sheetName == "Transaction") {
              data = data1;
            } else {
              ledgerData = data1;
            }
          });

          // if file is empty
          if (data?.length === 0 || data === undefined) {
            toast.error("File Should not be empty");
            setfileData([]);
            setFileDataCount(0);
            setFileName("");
            return;
          }

          // filter if there is any empty header key
          const uploadedHeaders = Object.keys(data[0])
            ?.filter((ele) => !ele?.includes("__EMPTY"))
            .map((item) => item.trim()?.toLowerCase()); // remvoving spaces for better matching

          let hasDuplicate = false;
          data
            .map((ele2) => ele2?.txnid)
            ?.sort()
            ?.sort((a, b) => {
              if (a === b) hasDuplicate = true;
            });

          const settlementDateCheck = !data?.some((ele1) => {
            const dateToCheck = ele1?.SettlementDate;
            return moment(dateToCheck).isSameOrAfter(moment(), "day");
          });

          if (!settlementDateCheck) {
            toast.error("Settlement date must be before the today date.");
            setfileData([]);
            setFileDataCount(0);
            setFileName("");
            return;
          }

          const headersMatch = arrAllHeadings?.every((header, index) => {
            return uploadedHeaders.includes(header.trim()?.toLowerCase());
          });

          if (
            headersMatch === false ||
            arrAllHeadings?.length !== uploadedHeaders?.length
          ) {
            toast.error(
              "Uploaded file headers do not match the expected format.",
            );
            setfileData([]);
            setFileDataCount(0);
            setFileName("");
            return;
          }

          if (
            data.some(
              (ele) =>
                !allAvailableFunds?.includes(
                  ele?.FundCode?.toUpperCase()?.trim(),
                ),
            )
          ) {
            const indexOfErr = data?.findIndex(
              (item) =>
                !allAvailableFunds?.includes(
                  item?.FundCode?.toUpperCase()?.trim(),
                ),
            );

            toast.error(
              `Invalid fund code. Please enter a valid fund for row ${indexOfErr + 2}`,
            );
            setfileData([]);
            setFileDataCount(0);
            setFileName("");
            return;
          }

          if (
            !uploadedHeaders?.includes("transactiontype") ||
            data?.some((ele) => ele?.TransactionType?.trim() == "")
          ) {
            const indexOfErr = data?.findIndex(
              (item) => item?.TransactionType?.trim() == "",
            );

            toast.error(
              `Transaction Type should not be empty for row ${indexOfErr + 2}`,
            );
            setfileData([]);
            setFileDataCount(0);
            setFileName("");
            return;
          }

          if (
            data?.some(
              (ele) => !validTXNType?.includes(ele?.TransactionType?.trim()),
            )
          ) {
            const indexOfErr = data?.findIndex(
              (item) => !validTXNType?.includes(item?.TransactionType?.trim()),
            );

            toast.error(
              `Transaction type should be valid for row ${indexOfErr + 2}`,
            );
            setfileData([]);
            setFileDataCount(0);
            setFileName("");
            return;
          }

          if (data?.some((ele) => ele?.txnid?.trim() == "")) {
            const indexOfErr = data?.findIndex(
              (item) => item?.txnid?.trim() == "",
            );

            toast.error(
              `Transaction ID should not be empty for row ${indexOfErr + 2}`,
            );
            setfileData([]);
            setFileDataCount(0);
            setFileName("");
            return;
          }

          if (hasDuplicate) {
            toast.error(`Transaction Id should not be same`);
            setfileData([]);
            setFileDataCount(0);
            setFileName("");
            return;
          }

          if (
            data.some(
              (ele) =>
                !activeUnitHolders?.includes(
                  ele?.FolioNumber?.toUpperCase()?.trim(),
                ),
            ) &&
            data?.some((ele) =>
              investmentTXN?.includes(ele?.TransactionType?.trim()),
            )
          ) {
            const indexOfErr = data?.findIndex(
              (item) =>
                !activeUnitHolders?.includes(
                  item?.FolioNumber?.toUpperCase()?.trim(),
                ),
            );

            toast.error(
              `Invalid Folio No. Please enter a valid Folio for row ${indexOfErr + 2}`,
            );
            setfileData([]);
            setFileDataCount(0);
            setFileName("");
            return;
          }

          if (
            data?.some(
              (ele) => ele?.TransactionType?.trim() === "debtmarketinvestment",
            )
          ) {
            const validSecurityNames = allSecurities?.map((ele) =>
              ele?.name?.toLowerCase()?.trim(),
            );
            const validSecurityTypeLabels = getAllSecurityTypesArr?.map((ele) =>
              ele?.label?.toLowerCase()?.trim(),
            );

            const securityNameErrorIndex = data?.findIndex(
              (item) =>
                item?.TransactionType?.trim() === "debtmarketinvestment" &&
                !validSecurityNames?.includes(
                  item?.Security?.toLowerCase()?.trim(),
                ),
            );

            if (securityNameErrorIndex !== -1) {
              toast.error(
                `Security name does not exist in system for row ${securityNameErrorIndex + 2}`,
              );
              setfileData([]);
              setFileDataCount(0);
              setFileName("");
              return;
            }

            const securityTypeErrorIndex = data?.findIndex(
              (item) =>
                item?.TransactionType?.trim() === "debtmarketinvestment" &&
                !validSecurityTypeLabels?.includes(
                  item?.["Securities/Placement"]?.toLowerCase()?.trim(),
                ),
            );

            if (securityTypeErrorIndex !== -1) {
              toast.error(
                `Securities/Placement does not exist in system for row ${securityTypeErrorIndex + 2}`,
              );
              setfileData([]);
              setFileDataCount(0);
              setFileName("");
              return;
            }
          }

          const checkRequiredFields = (data, requiredFields) => {
            return data.some((row) => {
              return requiredFields.some((field) => {
                const value = row[field.trim()]?.toString().trim(); // get trim valu
                return !value; // true if valu is emoty
              });
            });
          };

          const hasEmptyRedemptionFields =
            data.some((ele) => ele.TransactionType === "redemptionofunits") &&
            checkRequiredFields(
              data.filter((ele) => ele.TransactionType === "redemptionofunits"),
              requiredRedemptionOfUnit,
            );
          const hasEmptySalesFields =
            data.some((ele) => ele.TransactionType === "saleofunit") &&
            checkRequiredFields(
              data.filter((ele) => ele.TransactionType === "saleofunit"),
              requiredSaleOfUnit,
            );
          const hasEmptyConversionInFields =
            data.some((ele) => ele.TransactionType === "conversionin") &&
            checkRequiredFields(
              data.filter((ele) => ele.TransactionType === "conversionin"),
              requiredConversionInUnit,
            );
          const hasEmptyConversionOutFields =
            data.some((ele) => ele.TransactionType === "conversionout") &&
            checkRequiredFields(
              data.filter((ele) => ele.TransactionType === "conversionout"),
              requiredConversionOutUnit,
            );
          const hasEmptyTransferOutFields =
            data.some((ele) => ele.TransactionType === "transferout") &&
            checkRequiredFields(
              data.filter((ele) => ele.TransactionType === "transferout"),
              requiredRedemptionOfUnit,
            );
          const hasEmptyTransferInFields =
            data.some((ele) => ele.TransactionType === "transferin") &&
            checkRequiredFields(
              data.filter((ele) => ele.TransactionType === "transferin"),
              requiredSaleOfUnit,
            );
          const hasEmptyTransferLienOutFields =
            data.some((ele) => ele.TransactionType === "transferlienout") &&
            checkRequiredFields(
              data.filter((ele) => ele.TransactionType === "transferlienout"),
              requiredRedemptionOfUnit,
            );
          const hasEmptyTransferLienInFields =
            data.some((ele) => ele.TransactionType === "transferlienin") &&
            checkRequiredFields(
              data.filter((ele) => ele.TransactionType === "transferlienin"),
              requiredSaleOfUnit,
            );

          // --------- New Added -------------
          const hasEmptyBonusInFields =
            data.some((ele) => ele.TransactionType === "bonus") &&
            checkRequiredFields(
              data.filter((ele) => ele.TransactionType === "bonus"),
              requiredSaleOfUnit,
            );
          const hasEmptyBonusEncashmentInFields =
            data.some((ele) => ele.TransactionType === "bonusencashment") &&
            checkRequiredFields(
              data.filter((ele) => ele.TransactionType === "bonusencashment"),
              requiredRedemptionOfUnit,
            );
          const hasEmptyTaxOnBonusEncashmentInFields =
            data.some(
              (ele) => ele.TransactionType === "taxonbonusencashment",
            ) &&
            checkRequiredFields(
              data.filter(
                (ele) => ele.TransactionType === "taxonbonusencashment",
              ),
              requiredRedemptionOfUnit,
            );
          const hasEmptyDividendInFields =
            data.some((ele) => ele.TransactionType === "dividend") &&
            checkRequiredFields(
              data.filter((ele) => ele.TransactionType === "dividend"),
              requiredSaleOfUnit,
            );
          const hasEmptyTaxOnDividendInFields =
            data.some((ele) => ele.TransactionType === "taxondividend") &&
            checkRequiredFields(
              data.filter((ele) => ele.TransactionType === "taxondividend"),
              requiredRedemptionOfUnit,
            );
          const hasEmptyDividendPaidInFields =
            data.some((ele) => ele.TransactionType === "dividendpaid") &&
            checkRequiredFields(
              data.filter((ele) => ele.TransactionType === "dividendpaid"),
              requiredRedemptionOfUnit,
            );
          const hasEmptyDividendReinvestmentInFields =
            data.some(
              (ele) => ele.TransactionType === "dividendreinvestment",
            ) &&
            checkRequiredFields(
              data.filter(
                (ele) => ele.TransactionType === "dividendreinvestment",
              ),
              requiredSaleOfUnit,
            );
          // const hasEmptyTaxableDividendInFields = data.some(ele => ele.TransactionType === "taxabledividend") && checkRequiredFields(data.filter(ele => ele.TransactionType === "taxabledividend"), requiredTaxableDividend);
          const hasEmptyRefundOfCapitalInFields =
            data.some((ele) => ele.TransactionType === "refundofcapital") &&
            checkRequiredFields(
              data.filter((ele) => ele.TransactionType === "refundofcapital"),
              requiredSaleOfUnit,
            );
          // const hasEmptyCgtOnConversionInFields = data.some(ele => ele.TransactionType === "cgtonconversion") && checkRequiredFields(data.filter(ele => ele.TransactionType === "cgtonconversion"), requiredCgtOnConversion);
          // const hasEmptyCgtOnConversionOutInFields = data.some(ele => ele.TransactionType === "cgtonconversionout") && checkRequiredFields(data.filter(ele => ele.TransactionType === "cgtonconversionout"), requiredCgtOnConversionOut);
          // const hasEmptyCgtOnTransferInFields = data.some(ele => ele.TransactionType === "cgtontransfer") && checkRequiredFields(data.filter(ele => ele.TransactionType === "cgtontransfer"), requiredCgtOnTransfer);
          // const hasEmptyCgtOnRedemptionInFields = data.some(ele => ele.TransactionType === "cgtonredemption") && checkRequiredFields(data.filter(ele => ele.TransactionType === "cgtonredemption"), requiredCgtOnRedemption);
          const hasEmptyCgtRefundInFields =
            data.some((ele) => ele.TransactionType === "cgtrefund") &&
            checkRequiredFields(
              data.filter((ele) => ele.TransactionType === "cgtrefund"),
              requiredSaleOfUnit,
            );
          const hasEmptyZakatOnBonusEncashmentInFields =
            data.some(
              (ele) => ele.TransactionType === "zakatonbonusencashment",
            ) &&
            checkRequiredFields(
              data.filter(
                (ele) => ele.TransactionType === "zakatonbonusencashment",
              ),
              requiredRedemptionOfUnit,
            );
          const hasEmptyZakatOnDividendInFields =
            data.some((ele) => ele.TransactionType === "zakatondividend") &&
            checkRequiredFields(
              data.filter((ele) => ele.TransactionType === "zakatondividend"),
              requiredRedemptionOfUnit,
            );
          const hasEmptyMMInFields =
            data.some(
              (ele) => ele.TransactionType === "debtmarketinvestment",
            ) &&
            checkRequiredFields(
              data.filter(
                (ele) => ele.TransactionType === "debtmarketinvestment",
              ),
              requiredMM,
            );

          if (
            hasEmptyRedemptionFields ||
            hasEmptySalesFields ||
            hasEmptyConversionInFields ||
            hasEmptyConversionOutFields ||
            hasEmptyTransferOutFields ||
            hasEmptyTransferInFields ||
            hasEmptyTransferLienOutFields ||
            hasEmptyTransferLienInFields ||
            hasEmptyZakatOnDividendInFields ||
            hasEmptyZakatOnBonusEncashmentInFields ||
            hasEmptyCgtRefundInFields ||
            hasEmptyRefundOfCapitalInFields ||
            hasEmptyDividendReinvestmentInFields ||
            hasEmptyDividendPaidInFields ||
            hasEmptyTaxOnDividendInFields ||
            hasEmptyDividendInFields ||
            hasEmptyTaxOnBonusEncashmentInFields ||
            hasEmptyBonusEncashmentInFields ||
            hasEmptyBonusInFields ||
            hasEmptyMMInFields
          ) {
            setErrorInFile(true);
          } else {
            setErrorInFile(false);
          }

          if (data.length > 0) {
            // filter those keys which has ___Empty
            const filteredData = data.map((obj) => {
              return Object.fromEntries(
                Object.entries(obj).filter(
                  ([key]) => !key.startsWith("__EMPTY"),
                ),
              );
            });

            // const ledgerdataKey = ledgerData?.map((item) => {
            //     return {
            //         amount_type: item?.AmountType?.trim(),
            //         child_family_code: item?.ChildFamilyCode?.trim(),
            //         child_family_name: item?.ChildFamilyName?.trim(),
            //         credit_amount: item?.Credit?.trim(),
            //         debit_amount: item?.Debit?.trim(),
            //         family_code: item?.FamilyCode?.trim(),
            //         family_name: item?.FamilyName?.trim(),
            //         gl_code: item?.GlCode?.trim(),
            //         gl_name: item?.GlName?.trim(),
            //         main_family_code: item?.MainFamilyCode?.trim(),
            //         main_family_name: item?.MainFamilyName?.trim(),
            //         sub_family_code: item?.SubFamilyCode?.trim(),
            //         sub_family_name: item?.SubFamilyName?.trim(),
            //         type: item?.Type?.trim(),
            //         txnid: item?.txnid?.trim(),
            //         description: item?.Description?.trim()
            //     }
            // }
            // )

            let tradeSettlement = false;

            const securitiesData = filteredData?.map((item, index) => {
              const symbolIs = allSecurities?.find(
                (ele) => ele?.name?.trim() === item?.Security?.trim(),
              )?.code;
              tradeSettlement =
                item?.TransactionType === "debtmarketinvestment";
              const securityTypeIs = getAllSecurityTypesArr?.find(
                (ele) => ele?.label === item?.["Securities/Placement"]?.trim(),
              )?.value;
              return {
                txnid: item?.txnid?.trim(),
                security_type: securityTypeIs || "",
                investment_type: item?.InvestmentType?.trim(),
                type: item?.Type?.trim(),
                symbol: symbolIs?.trim(),
                name: item?.Security?.trim(),
                issue_date: item?.IssueDate?.trim(),
                maturity_date: item?.MaturityDate?.trim(),
                money_market_face_value: item?.["MoneyMarketFaceValue/Unit"]
                  ?.trim()
                  ?.replaceAll(",", ""),
                price: item?.PurchasePrice?.trim()?.replaceAll(",", ""),
                units: item?.Units?.trim()?.replaceAll(",", ""),
                yield: item?.["Yield/InterestRate"]
                  ?.trim()
                  ?.replaceAll(",", ""),
                coupon_rate: item?.CouponRate?.trim()?.replaceAll(",", ""),
                next_coupon_date: item?.NextCouponDate?.trim(),
                last_coupon_date: item?.LastCouponDate?.trim(),
                primary_dealer: item?.PrimaryDealer?.trim(),
                fund_ips_account: item?.FundIPSAccount?.trim(),
                counter_party_ips_account: item?.CounterPartyIPSAccount?.trim(),
                broker_name: item?.BrokerName?.trim(),
                settlement_amount: item?.SettlementAmount?.trim()?.replaceAll(
                  ",",
                  "",
                ),
                total_face_value:
                  item?.SecurityTotalFaceValue?.trim()?.replaceAll(",", ""),
                accrued_amount: item?.SecurityAccruedAmount?.trim()?.replaceAll(
                  ",",
                  "",
                ),
                brokerage: item?.SecurityBrokerage?.trim(),
                premium_discount: item?.["Premium/Discount"]
                  ?.trim()
                  ?.replaceAll(",", ""),
                accrued_days: item?.AccruedDays?.trim(),
                counter_party_name: item?.CounterPartyName?.trim(),
                detail: item?.SecurityDetail?.trim(),
                principal_amount:
                  item?.SecurityPrincipalAmount?.trim()?.replaceAll(",", ""),
                unredeem_value: item?.UnRedeemValue?.trim()?.replaceAll(
                  ",",
                  "",
                ),
                coupon_payment: item?.["CouponPayment/Year"]
                  ?.trim()
                  ?.replaceAll(",", ""),
                days_of_maturity: item?.DaysOfMaturity?.trim(),
                average_cost_per_unit: item?.["AverageCost/Unit"]
                  ?.trim()
                  ?.replaceAll(",", ""),
                average_cost_amount:
                  item?.SecurityAverageCostAmount?.trim()?.replaceAll(",", ""),
                gain_loss_per_unit: item?.["Gain/LossPerUnit"]
                  ?.trim()
                  ?.replaceAll(",", ""),
                gain_loss_amount: item?.["Gain/LossAmount"]
                  ?.trim()
                  ?.replaceAll(",", ""),
                coupon_days: item?.CouponDays?.trim(),
                settlement_date: item?.SettlementDate?.trim(),
              };
            });

            let temp: any = [];

            filteredData?.map((ele) => {
              const stringifySecurities = JSON.stringify(
                securitiesData
                  ?.filter(
                    (idTxn) => idTxn?.txnid?.trim() == ele?.txnid?.trim(),
                  )
                  ?.map(({ txnid, ...res }) => res) || [],
              );
              const obj: any = {
                email: email,
                txnr_type: ele?.TransactionType?.trim(),
                amc_code: amcCode,
                dividend_date: ele?.DividendCreditDate?.trim(),
                // dividend_date: "",
                dividend_rate: ele?.DividendAmount?.replaceAll(",", "")?.trim(),
                // dividend_rate: "",
                fund_code: ele?.FundCode?.trim(),
                reinvest: "false",
                instruction_date:
                  ele?.InstructionDate?.trim() ||
                  moment(date).format("YYYY-MM-DD"),
                execution_date: ele?.SettlementDate?.trim() || "",
                executed_date: moment(date).format("YYYY-MM-DD"),
                fund_account: ele?.FundAccount?.trim(),
                account_title: ele?.AccountTitle?.trim(),
                account_no: ele?.AccountNumber?.trim(),
                bank: ele?.Bank?.trim(),
                branch: ele?.Branch?.trim(),
                counter_account_type: "",
                counter_type: "",
                counter_account_title: ele?.CounterAccountTitle?.trim(),
                counter_account_number: ele?.CounterAccountNumber?.trim(),
                counter_bank: ele?.CounterBank?.trim(),
                counter_branch: ele?.CounterBranch?.trim(),
                mode_of_payment: ele?.ModeofPayment?.trim(),
                payment_type: ele?.PaymentType?.trim(),
                instrument_no: ele?.["InstrumentNo./ReferenceNo"]?.trim(),
                instrument_type: ele?.InstrumentType?.trim(),
                // instrument_type: "None",
                instrument_date:
                  ele?.["InstrumentDate/DepositDate"]?.trim() ||
                  moment(date).format("YYYY-MM-DD"),
                // realized_date: moment(date).format('YYYY-MM-DD'),
                realized_date: moment(date).format("YYYY-MM-DD"),
                realized: "true",
                gross_amount: ele?.GrossAmount?.replaceAll(",", "")?.trim(),
                net_amount: ele?.NetAmount?.replaceAll(",", "")?.trim(),
                dr_amount: "",
                period: sessionStorage.getItem("active_period") || "",
                cr_amount: "",
                balance: ele?.Balance?.replaceAll(",", "")?.trim(),
                folio_no: ele?.FolioNumber?.trim(),
                unitholder_name: ele?.UnitHolderName?.trim(),
                units:
                  ele?.TransactionType == "saleofunit" ||
                  ele?.TransactionType == "conversionin" ||
                  ele?.TransactionType == "transferlienin" ||
                  ele?.TransactionType == "cgtrefund" ||
                  ele?.TransactionType == "refundofcapital" ||
                  ele?.TransactionType == "dividendreinvestment" ||
                  ele?.TransactionType == "dividend" ||
                  ele?.TransactionType == "bonus" ||
                  ele?.TransactionType == "transferin"
                    ? ele?.Unitssold?.replaceAll(",", "")?.trim()
                    : ele?.TransactionType == "redemptionofunits" ||
                        ele?.TransactionType == "conversionout" ||
                        ele?.TransactionType == "transferlienout" ||
                        ele?.TransactionType == "zakatondividend" ||
                        ele?.TransactionType == "zakatonbonusencashment" ||
                        ele?.TransactionType == "dividendpaid" ||
                        ele?.TransactionType == "taxondividend" ||
                        ele?.TransactionType == "taxonbonusencashment" ||
                        ele?.TransactionType == "bonusencashment" ||
                        ele?.TransactionType == "transferout"
                      ? ele?.UnitsRedeemed?.replaceAll(",", "")?.trim()
                      : "",
                nav: ele?.NAVPrice?.replaceAll(",", "")?.trim(),
                sale_date:
                  ele?.SaleDate?.trim() || moment(date).format("YYYY-MM-DD"),
                current_holding:
                  ele?.CurrentHolding?.replaceAll(",", "")?.trim() || "0",
                total_holding:
                  ele?.TotalHolding?.replaceAll(",", "")?.trim() || "",
                // total_holding: "",
                symbol: ele?.Symbol?.trim() || "",
                dividend_percentage: ele?.DividendPercentage?.replaceAll(
                  ",",
                  "",
                )?.trim(),
                // dividend_percentage: "",
                credit_date: "",
                maturity_type: "",
                security_type: "",
                principal_amount: ele?.PrincipalAmount?.trim()?.replaceAll(
                  ",",
                  "",
                ),
                issue_date:
                  ele?.IssueDate?.trim() || moment(date).format("YYYY-MM-DD"),
                conversion_date: moment(date).format("YYYY-MM-DD"),
                associated_transaction: "",
                maturity_date:
                  ele?.MaturityDate?.trim() ||
                  moment(date).format("YYYY-MM-DD"),
                coupon_rate: ele?.CouponRate?.replaceAll(",", "")?.trim(),
                premium_discount: ele?.PremiumDiscount?.trim()?.replaceAll(
                  ",",
                  "",
                ),
                // coupon_rate: "",
                price: "",
                face_value: "",
                money_market_face_value: ele?.["MoneyMarketFaceValue/Unit"]
                  ?.replaceAll(",", "")
                  ?.trim(),
                // money_market_face_value: "",
                detail: ele?.Detail?.trim(),
                type: ele?.Type?.trim(),
                // type: "",
                redemption_date:
                  ele?.RedemptionDate?.trim() ||
                  moment(date).format("YYYY-MM-DD"),
                remain_holding:
                  ele?.RemainingHolding?.replaceAll(",", "")?.trim() || "0",
                // remain_holding: "0",
                settlement_by: ele?.SettlementBy?.trim(),
                // tax_type: ele?.TaxType?.trim(),
                tax_type: "",
                settlement_date: ele?.SettlementDate?.trim() || "",
                total_charges: "0",
                total_face_value:
                  ele?.TotalFaceValue?.trim()?.replaceAll(",", "") || "",
                txn_charges: "",
                sale_txn_no: "",
                return_date: "",
                txn_id: "",
                last_coupon_date:
                  ele?.LastCouponDate?.trim() ||
                  moment(date).format("YYYY-MM-DD"),
                next_coupon_date:
                  ele?.NextCouponDate?.trim() ||
                  moment(date).format("YYYY-MM-DD"),
                yield: ele?.["Yield/InterestRate"]?.replaceAll(",", ""),
                // yield: "",
                tenor: "",
                fund_ips_account: ele?.FundIPSAccount?.trim(),
                // fund_ips_account: "",
                // counter_party_ips_account: ele?.CounterPartyIPSAccount?.trim(),
                counter_party_ips_account: "",
                system_tax: "",
                primary_dealer: ele?.PrimaryDealer?.trim(),
                // primary_dealer: "",
                broker_commission: ele?.BrokerageCommission?.trim(),
                // broker_commission: "",
                tax_sst: "",
                tax_wht_it: "",
                tax_wht_sst: "",
                tax_cgt:
                  ele?.TransactionType == "redemptionofunits" ||
                  ele?.TransactionType == "transferlienout" ||
                  ele?.TransactionType == "transferout"
                    ? ele?.CGT?.replaceAll(",", "")?.trim()
                    : ele?.TransactionType == "conversionout"
                      ? ele?.CGT?.replaceAll(",", "")?.trim()
                      : "0",
                sale_load: ele?.SaleLoad?.replaceAll(",", "")?.trim(),
                redemption_load: ele?.RedemptionLoad?.replaceAll(
                  ",",
                  "",
                )?.trim(),
                low_balance_agree: "",
                offer_price: ele?.SalePrice?.replaceAll(",", "")?.trim(),
                // offer_price: "30",
                load_per_unit: ele?.ApplicableUnitLoad?.replaceAll(
                  ",",
                  "",
                )?.trim(),
                // load_per_unit: "10",
                percentage_of_discount: ele?.DiscountonLoad?.replaceAll(
                  ",",
                  "",
                )?.trim(),
                applicable_offer_price: ele?.ApplicablePrice?.replaceAll(
                  ",",
                  "",
                )?.trim(),
                sales_tax_collector: ele?.SalesTaxCollector?.trim() || "SRB", // default value SRB
                volume: ele?.Volume?.replaceAll(",", "")?.trim(),
                // volume: "",
                par_value: ele?.ParValue?.replaceAll(",", "")?.trim(),
                // par_value: "",
                announcement_date: ele?.AnnouncementDate?.trim(), // Dividend on Investment
                bonus_percentage: ele?.BonusPercentage?.trim(),
                // bonus_percentage: "",
                bonus_credit_date: ele?.BonusCreditDate?.trim(),
                // bonus_credit_date: "",
                bonus_gross_volume: "",
                tax_it_bonus_amount: "",
                net_bonus_volume: "",
                // right_share_percentage: ele?.RightSharePercentage?.trim(),
                right_share_percentage: "",
                right_share_credit_date: ele?.RightShareCreditDate?.trim(),
                right_share_gross_volume: "",
                tax_it_right_share_amount: "",
                net_right_share_volume: "",
                tax_on_dvidend: "",
                tax_on_bonus: "",
                tax_on_right: "",
                zakat_amount: ele?.Zakat?.replaceAll(",", "")?.trim() || "0",
                // zakat_amount: "0.00",
                ledgers: "[]",
              };
              if (tradeSettlement) {
                obj.securities = stringifySecurities;
                obj.average_cost_amount =
                  ele?.AverageCostAmount?.trim()?.replaceAll(",", "");
                obj.gain_loss_amount = ele?.["GainLossAmount"]
                  ?.trim()
                  ?.replaceAll(",", "");
                obj.brokerage = ele?.Brokerage?.trim();
                obj.accrued_amount = ele?.AccruedAmount?.trim()?.replaceAll(
                  ",",
                  "",
                );
              }
              // setFields(obj)
              temp.push(obj);
            });
            setMegatxnObj(temp);

            setfileData(filteredData);
            setFileDataCount(data.length);
          }
        };
        if (rABS) reader.readAsBinaryString(file);
        else reader.readAsArrayBuffer(file);
      } else {
        toast.error("Please Upload Correct Format of File");
        setfileData([]);
        setFileDataCount(0);
        setFileName("");
      }
      // removing value so that user can upload same file again
      e.target.value = "";
    }
  };

  const requiredFieldsMap = {
    saleofunit: requiredSaleOfUnit,
    redemptionofunits: requiredRedemptionOfUnit,
    conversionout: requiredConversionOutUnit,
    conversionin: requiredConversionInUnit,
    transferout: requiredRedemptionOfUnit,
    transferin: requiredSaleOfUnit,
    transferlienout: requiredRedemptionOfUnit,
    transferlienin: requiredSaleOfUnit,
    bonus: requiredSaleOfUnit,
    bonusencashment: requiredRedemptionOfUnit,
    taxonbonusencashment: requiredRedemptionOfUnit,
    dividend: requiredSaleOfUnit,
    taxondividend: requiredRedemptionOfUnit,
    dividendpaid: requiredRedemptionOfUnit,
    dividendreinvestment: requiredSaleOfUnit,
    refundofcapital: requiredSaleOfUnit,
    cgtrefund: requiredSaleOfUnit,
    zakatonbonusencashment: requiredRedemptionOfUnit,
    zakatondividend: requiredRedemptionOfUnit,
    debtmarketinvestment: requiredMM,
  };

  const renderTable = () => {
    return fileData?.map((item: any, index: number) => {
      return (
        <tr key={index}>
          {Object.entries(item).map(([key, value]: [string, any]) => {
            let isHighlighted = false;
            // if (item?.TransactionType === "saleofunit" && requiredSaleOfUnit?.includes(key) && value?.trim() === "") {
            //     isHighlighted = true;
            // } else if (item?.TransactionType === "redemptionofunits" && requiredRedemptionOfUnit?.includes(key) && value?.trim() === "") {
            //     isHighlighted = true;
            // } else if (item?.TransactionType === "conversionout" && requiredConversionOutUnit?.includes(key) && value?.trim() === "") {
            //     isHighlighted = true;
            // } else if (item?.TransactionType === "conversionin" && requiredConversionInUnit?.includes(key) && value?.trim() === "") {
            //     isHighlighted = true;
            // } else if (item?.TransactionType === "transferout" && requiredTransferOutUnit?.includes(key) && value?.trim() === "") {
            //     isHighlighted = true;
            // } else if (item?.TransactionType === "transferin" && requiredTransferInUnit?.includes(key) && value?.trim() === "") {
            //     isHighlighted = true;
            // } else if (item?.TransactionType === "transferlienout" && requiredTransferLienOutUnit?.includes(key) && value?.trim() === "") {
            //     isHighlighted = true;
            // } else if (item?.TransactionType === "transferlienin" && requiredTransferLienInUnit?.includes(key) && value?.trim() === "") {
            //     isHighlighted = true;
            // } else if (item?.TransactionType === "bonus" && requiredBonusInUnit?.includes(key) && value?.trim() === "") {
            //     isHighlighted = true;
            // } else if (item?.TransactionType === "bonusencashment" && requiredBonusEncashmentInUnit?.includes(key) && value?.trim() === "") {
            //     isHighlighted = true;
            // } else if (item?.TransactionType === "taxonbonusencashment" && requiredTaxOnBonusEncashmentInUnit?.includes(key) && value?.trim() === "") {
            //     isHighlighted = true;
            // } else if (item?.TransactionType === "dividend" && requiredDividendInUnit?.includes(key) && value?.trim() === "") {
            //     isHighlighted = true;
            // } else if (item?.TransactionType === "taxondividend" && requiredTaxOnDividendInUnit?.includes(key) && value?.trim() === "") {
            //     isHighlighted = true;
            // } else if (item?.TransactionType === "dividendpaid" && requiredDividendPaidInUnit?.includes(key) && value?.trim() === "") {
            //     isHighlighted = true;
            // } else if (item?.TransactionType === "dividendreinvestment" && requiredDividendReinvestmentInUnit?.includes(key) && value?.trim() === "") {
            //     isHighlighted = true;
            // } else if (item?.TransactionType === "refundofcapital" && requiredRefundOfCapitalInUnit?.includes(key) && value?.trim() === "") {
            //     isHighlighted = true;
            // } else if (item?.TransactionType === "cgtrefund" && requiredCgtRefundInUnit?.includes(key) && value?.trim() === "") {
            //     isHighlighted = true;
            // } else if (item?.TransactionType === "zakatonbonusencashment" && requiredZakatOnBonusEncashmentInUnit?.includes(key) && value?.trim() === "") {
            //     isHighlighted = true;
            // } else if (item?.TransactionType === "zakatondividend" && requiredZakatOnDividendInUnit?.includes(key) && value?.trim() === "") {
            //     isHighlighted = true;
            // }

            isHighlighted = shouldHighlight(
              item,
              key,
              value,
              requiredFieldsMap,
            );
            return (
              <td
                key={key}
                style={{
                  backgroundColor: isHighlighted ? "#8b0000" : "",
                  border: "1px solid #525f7f",
                }}
              >
                {typeof value === "number"
                  ? numberWithCommas(value.toFixed(4))
                  : value}
              </td>
            );
          })}
        </tr>
      );
    });
  };

  const handleUploadFiles = async () => {
    setLoadingFileUpload(true);
    if (errorInFile === true) {
      toast.error("First fill the required fields");
      setLoadingFileUpload(false);
      return;
    }
    try {
      let res = await legacyUploaderTXN(email, amcCode, megatxnObj);
      if (res?.status === 200 && res?.data?.status === 200) {
        toast.success(res?.data?.message);
      } else {
        toast.error("Error Uploading File");
      }
    } catch (error) {
      toast.error("Error Uploading File");
    } finally {
      setErrorInFile(false);
      setLoadingFileUpload(false);
      setMegatxnObj([]);
      setfileData([]);
      setFileDataCount(0);
      setFileName("");
    }
  };

  return (
    <div className="content">
      {console.log("megatxnObj", megatxnObj)}
      <Row>
        <Col md="12">
          <Container fluid>
            <ToastContainer limit={1} />
            <div className="card">
              <div className="">
                <div className="card-header">
                  <h4 className="card-title">
                    Legacy Transactions Bulk Upload
                    <Dropdown className="float-right">
                      <Dropdown.Toggle
                        href={`${env.REACT_APP_SAMPLE_URL}TXN.xlsx`}
                        variant="dark"
                        id="dropdown-basic"
                      >
                        Download Sample
                      </Dropdown.Toggle>
                    </Dropdown>
                  </h4>
                </div>
                {apiLoading == true ? (
                  <Row className="d-flex justify-content-center my-3">
                    <i
                      className="fa fa-spinner fa-spin fa-3x"
                      aria-hidden="true"
                    ></i>
                  </Row>
                ) : (
                  <div className="card-body">
                    <Row className="mb-3">
                      <Col lg="6" xl="6" md="12" sm="12" xs="12">
                        <label>Choose File </label>
                        <div
                          className="form-control multi-input ml-auto"
                          style={{
                            cursor: "pointer",
                          }}
                          onClick={() => myRef1?.current?.click()}
                        >
                          <div className="form-group mb-0">
                            <div className="fom-control ml-2">
                              {fileName === "" ? "Upload File" : fileName}
                            </div>
                            <input
                              className="form-control"
                              type="file"
                              ref={myRef1}
                              style={{ display: "none" }}
                              multiple={false}
                              onChange={(e) => {
                                upload(e);
                              }}
                            />
                            {fileError ? (
                              <p className="error-labels error-message2">
                                {fileError}
                              </p>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                        {fileUploadingFlag && (
                          <img src="assets/loader.svg" width="50" />
                        )}
                      </Col>
                    </Row>
                    {fileData?.length > 0 ? (
                      <div className="table-responsive">
                        <table className="table mt-3 ">
                          <thead>
                            {Object.keys(fileData?.[0])?.map((heading) => {
                              return (
                                <th
                                  style={{
                                    paddingLeft: "7px",
                                    paddingRight: "7px",
                                    border: "1px solid",
                                  }}
                                  className="text-nowrap"
                                >
                                  {heading}
                                </th>
                              );
                            })}
                          </thead>
                          <tbody>{renderTable()}</tbody>
                        </table>
                      </div>
                    ) : fileName ? (
                      <Row className="d-flex justify-content-center my-3">
                        <i
                          className="fa fa-spinner fa-spin fa-3x"
                          aria-hidden="true"
                        ></i>
                      </Row>
                    ) : null}
                    Total Rows:{" "}
                    <span className="text-primary mt-3">{fileDataCount} </span>
                    <div className="mt-4">
                      <button
                        className="btn btn-primary"
                        disabled={
                          Boolean(loading) ||
                          megatxnObj?.length < 1 ||
                          loadingFileUpload
                        }
                        onClick={() => {
                          handleUploadFiles();
                        }}
                      >
                        {loadingFileUpload ? (
                          <>
                            <span
                              className="spinner-border login-txt spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            <span className="login-txt"> Loading...</span>
                          </>
                        ) : (
                          <span>Upload</span>
                        )}
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </Container>
        </Col>
      </Row>
    </div>
  );
};

export default LegacyPastTransactionUploader;
